import { createSlice } from "@reduxjs/toolkit";
import { getJattuActivityList, getJattuActivityByID,AddJattuActivity } from "./jattu_activityAction";

const jattuActivitySlice = createSlice({
    name: "jattuactivity",
    initialState: {
        error: "Sorry! No Data Found.",
        message: null,
        loading: false,
        unitsLoading: false,
        model: false,
        error_msg: null,
        rowdata: {},
        listCount: 0,
        jattuActivitylist: [],
        jattuActivityParams: {
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "code",
            sortOrder: "-",
        },

    },
    reducers: {

        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },
        SetjattuActivityParams: (state, action) => {
            return {
                ...state,
                jattuActivityParams: {
                    ...state.jattuActivityParams,
                    ...action.payload
                },
            };
        },
        isModelVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getJattuActivityList.pending, (state, action) => {
                state.status = "getJattuActivityList loading";
                state.loading = true;
            })
            .addCase(getJattuActivityList.fulfilled, (state, action) => {
                console.log(action.payload.response)
                state.status = "getJattuActivityList succeeded";
                state.loading = false;
                var response = action.payload.response;
                var noofpages = Math.ceil(
                    action.payload.count / state.jattuActivityParams?.page_size
                );

                state.jattuActivitylist = response.results;
                state.listCount = response.count;
                state.jattuActivityParams = {
                    ...state.jattuActivityParams,
                    no_of_pages: noofpages,
                };
            })
            .addCase(getJattuActivityList.rejected, (state, action) => {
                state.status = "getJattuActivityList failed";
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(getJattuActivityByID.pending, (state, action) => {
                state.status = "getJattuActivityByID loading";
                state.loading = true;
            })
            .addCase(getJattuActivityByID.fulfilled, (state, action) => {
                state.status = "getJattuActivityByID succeeded";
                state.loading = false
                state.rowdata = action.payload;
            }
            )
            .addCase(getJattuActivityByID.rejected, (state, action) => {
                state.status = "getJattuActivityByID failed";
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(AddJattuActivity.pending, (state, action) => {
                state.status = "AddJattuActivity loading";
                state.loading = true;
            })
            .addCase(AddJattuActivity.fulfilled, (state, action) => {
                state.status = "AddJattuActivity succeeded";
                state.loading = false
                state.model = action.payload.modal;
                state.message = action.payload.response;
                state.rowdata = {};
            }
            )
            .addCase(AddJattuActivity.rejected, (state, action) => {
                state.status = "AddJattuActivity failed";
                state.loading = false;
                state.error = action.error.message;
            })

    }

});
export const {
    InputChangeValue,
    SetjattuActivityParams,
    isModelVisible
} = jattuActivitySlice.actions;

export default jattuActivitySlice.reducer;